

































































































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import NationalHolidayDetailBase from "./NationalHolidayDetailBase";

	@Component
	export default class NationalHolidayDetail extends NationalHolidayDetailBase {

	 	 	
		created() {
			this.returnRoute = "NationalHolidayList";
			super.initializeRights('COR_NationalHoliday_Create', 'COR_NationalHoliday_Delete', 'COR_NationalHoliday_Read', 'COR_NationalHoliday_Update');
			super.setMainDescription('nationalHoliday.new', 'nationalHoliday.detail');
            this.mainDataChanged = false;
		}

        preventRefresh(event: any) {
            if (this.$store.state.askBeforeCancelEditing === true && this.formIsInEditMode && this.dataWasChanged()) {
                event.preventDefault(); event.returnValue = "";
            }
		}

        beforeMount() {
            window.addEventListener("beforeunload", this.preventRefresh);
        }

        beforeDestroy() {
            window.removeEventListener("beforeunload", this.preventRefresh);
            this.$store.commit("formIsInEditMode", false);
            this.$store.commit("mainDataChanged", false);
        }

		mounted() {
			super.mounted();
		};

		validate() {
			return this.validateBase();
		}

		isCorrectName(value: any) {
			this.isCorrectNameBase(value);
		}
		isCorrectDate(value: any) {
			this.isCorrectDateBase(value);
		}

		isCorrectMinDate(value: any) {
			this.isCorrectMinDateBase(value);
		}

		isCorrectMaxDate(value: any) {
			this.isCorrectMaxDateBase(value);
		}
	}
